import { FlatList } from 'react-native'
import ListItem from 'APP/Converse/ListItem'
import { DisplayResult } from './types'
import Analytics from 'APP/Services/Analytics'

type Props = {
  data: DisplayResult[]
  onResultPress: (item: DisplayResult) => void
}

type ResultItemProps = {
  item: DisplayResult
  onResultPress: (item: DisplayResult) => void
}

const ResultItem = ({ item, onResultPress }: ResultItemProps) => {
  return (
    <ListItem
      title={item.displayL2}
      subtitle={item.displayL1}
      hideIconComponent
      onPress={() => {
        Analytics.trackEvent('button_click', {
          button_value: 'Semantic Search - Result Item',
        })
        onResultPress(item)
      }}
    />
  )
}

const SearchResults = ({ data, onResultPress }: Props) => (
  <FlatList
    testID="SEMANTIC_SEARCH_RESULTS"
    data={data}
    keyExtractor={(item) => item.id}
    renderItem={({ item }) => <ResultItem item={item} onResultPress={onResultPress} />}
  />
)

export default SearchResults
